<template>
  <div>
    <haixueC v-if="type==1"></haixueC>
    <zg v-else-if="type==2"></zg>
    <zhuxue v-else></zhuxue>
  </div>

</template>

<script>
  import haixueC from './haixue';
  import zg from './zg';
  import zhuxue from './zhuxue';
    export default {
        name: "",
        components:{
          haixueC,
          zg,
          zhuxue
        },
      data () {
        return {
          type:0
        }
      },
       mounted(){
        let type=this.$route.query.type?this.$route.query.type:0
         this.type=type
      }
    }

</script>

<style scoped>

</style>
